import type { ExploreNavigationItem, ExploreNavigationProps } from "@newgenerated/shared/schema";
import type { GaVueComponent } from "@/common/vueUtils";
import "./_exploreBreadcrump.scss";
import { useGaContext } from "@utils/vue-migration/common/gaContext/gaContext";

function getSelectedSubTree(
  navigationItems: {
    item: ExploreNavigationItem;
    subItems: { item: ExploreNavigationItem }[];
  }[],
): { item: ExploreNavigationItem; subItems: { item: ExploreNavigationItem }[] } | null {
  // Iterate through the navigationItems looking for the first match
  for (const navItem of navigationItems) {
    // Check if the main item or any subItem has the selected property
    if (navItem.item.selected || navItem.subItems.some((subItem) => subItem.item.selected)) {
      return navItem; // Return the first tree that contains the selected item
    }
  }
  return null; // Return null if no matches are found
}

export const ExploreBreadcrumb = (props: { exploreNavigationProps: ExploreNavigationProps }): GaVueComponent => {
  const { t } = useGaContext();

  const actualTree = getSelectedSubTree(props.exploreNavigationProps.navigationItems);
  return (
    <nav class="explore_breadcrumb d-none d-lg-block pb-4 pt-2 ps-2" style="--ga-breadcrumb-divider: '>';" aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item explore__breadcrumb-item">
          <a href="/explore">
            <i class="ico-compass" />
            {t("general:nav.explore")}
          </a>
        </li>
        <li class={`breadcrumb-item explore__breadcrumb-item ${props.exploreNavigationProps.selected ? "selected" : ""}`}>
          {props.exploreNavigationProps.selected ? props.exploreNavigationProps.title : <a href={props.exploreNavigationProps.url}>{props.exploreNavigationProps.title}</a>}
        </li>
        {actualTree == null ? null : (
          <>
            <li class={`breadcrumb-item explore__breadcrumb-item ${actualTree.item.selected ? "selected" : ""}`}>{actualTree.item.selected ? actualTree.item.title : <a href={actualTree.item.url}>{actualTree.item.title}</a>}</li>
            {actualTree.subItems.map((item) => {
              if (!item.item.selected) {
                return null;
              }
              return (
                <li class="breadcrumb-item explore__breadcrumb-item selected" aria-current="page">
                  {item.item.title}
                </li>
              );
            })}
          </>
        )}
      </ol>
    </nav>
  );
};
